<template>
    <FciDialog :title="card ? card.name : ''" v-model="show" :width="width">
        <div class="CardDialog" :style="'max-height:' + height + 'px'">
            <component
                v-if="card"
                :key="card.code"
                :is="MapCardTypeToComponent[card.card_type_id] || CardDefault"
                :card="card"
                :highlight="false"
                :expandMode="true"
            ></component>
            <v-layout class="pa-3">
                <v-flex></v-flex>
                <v-btn color="primary" @click="done">{{ $f.tc('done') }}</v-btn>
            </v-layout>
        </div>
    </FciDialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogMixin from '@/modules/fptai/mixins/DialogMixin'
import { CardType } from '@/utils/const'
import CardText from '@/views/Scenario/StepEditor/Card/CardText'
import CardGoToStep from '@/views/Scenario/StepEditor/Card/CardGoToStep'
import CardQuickReply from '@/views/Scenario/StepEditor/Card/CardQuickReply'
import CardImage from '@/views/Scenario/StepEditor/Card/CardImage'
import CardCarousel from '@/views/Scenario/StepEditor/Card/CardCarousel'
import CardConfig from '@/views/Scenario/StepEditor/Card/CardConfig'
import CardAPI from '@/views/Scenario/StepEditor/Card/CardAPI'
import CardForm from '@/views/Scenario/StepEditor/Card/CardForm'
import CardHumanSupport from '@/views/Scenario/StepEditor/Card/CardHumanSupport'
import CardTag from '@/views/Scenario/StepEditor/Card/CardTag'
import CardTicket from '@/views/Scenario/StepEditor/Card/CardTicket'
import CardZaloList from '@/views/Scenario/StepEditor/Card/CardZaloList'
import CardUserLocation from '@/views/Scenario/StepEditor/Card/CardUserLocation'
import CardLuaScript from '@/views/Scenario/StepEditor/Card/CardLuaScript'
import CardGetCRM from '@/views/Scenario/StepEditor/Card/CardGetCRM'
import CardUpdateCRM from '@/views/Scenario/StepEditor/Card/CardUpdateCRM'
import CardDefault from '@/views/Scenario/StepEditor/Card/CardDefault'

const MapCardTypeToComponent = {
    [CardType.TEXT]: CardText,
    [CardType.GO_TO_STEP]: CardGoToStep,
    [CardType.QUICK_REPLY]: CardQuickReply,
    [CardType.IMAGE]: CardImage,
    [CardType.CAROUSEL]: CardCarousel,
    [CardType.CONFIG]: CardConfig,
    [CardType.JSON_API]: CardAPI,
    [CardType.FORM]: CardForm,
    [CardType.REQUEST_HUMAN_SUPPORT]: CardHumanSupport,
    [CardType.TAG]: CardTag,
    [CardType.TICKET]: CardTicket,
    [CardType.ZALO_LIST_TEMPLATE]: CardZaloList,
    [CardType.REQUEST_USER_LOCATION]: CardUserLocation,
    [CardType.LUA_SCRIPT]: CardLuaScript,
    [CardType.GET_SENDER_ATTRIBUTE]: CardGetCRM,
    [CardType.UPDATE_SENDER_ATTRIBUTE]: CardUpdateCRM
}

export default {
    name: 'CardDialog',
    components: { FciDialog },
    mixins: [DialogMixin],
    data () {
        return {
            MapCardTypeToComponent,
            CardDefault,
            card: null,
            width: 1000,
            height: 500
        }
    },
    methods: {
        open (card) {
            this.card = card
            this.show = true
            this.width = window.innerWidth - 20
            this.height = window.innerHeight - 140
        },
        done () {
            this.$store.dispatch(this.$at.scenario.SHOULD_UPDATE_GRAPH)
            this.close()
        }
    }
}
</script>

<style lang="scss">
.CardDialog {
    overflow: auto;

    .card {
        margin: 0;
    }
}
</style>
